import React from "react";
import get from "lodash/get";

import { displayDateTime } from "../../../../utils/dateDisplay";
const ActivityTab = ({ ca }) => {
  let activities = get(ca, "activities", []);

  return (
    <div className="activity has-background-white">
      {[...activities].reverse().map((activity) => {
        const { createTime, name, postponeWeeks, reason } = activity;

        const getTagClassName = (name) => {
          switch (name) {
            case "postpone":
              return "has-text-warning";
            case "cancel":
              return "has-text-danger";
            default:
              return "";
          }
        };

        return (
          <div key={createTime}>
            <div className="columns">
              <div className="column is-one-quarter pb-0" style={{ paddingTop: 8 }}>
                <i className={`fas fa-circle ${getTagClassName(name)}`} />{" "}
                <span className="title is-size-7 is-bold">Patient</span>
                <div className="is-size-7 is-light has-text-grey">
                  {displayDateTime(createTime, "YYYY-MM-DD HH:mm")}
                </div>
              </div>
              <div className="column pb-0" style={{ paddingTop: 8 }}>
                <span className="title is-size-7 is-bold">{`${name.toUpperCase()}${
                  postponeWeeks ? `(${postponeWeeks} weeks)` : ""
                }`}</span>
                {reason && <div className="is-size-7 is-light">{`Because ${reason}`}</div>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityTab;
